import {
  CrudBuilderState,
  didError,
  didSucceed,
  getFetchSlice,
  hasStarted
} from "seneca-common/utils/apiStates";

function getSectionStatFetchStateSlice(
  state: CrudBuilderState,
  courseId: string
) {
  const fetchSlice = getFetchSlice(state);
  return fetchSlice && fetchSlice.get(courseId);
}

export function allSectionStatsForCourseFetching(
  state: CrudBuilderState,
  courseId: string
): boolean {
  const meta = getSectionStatFetchStateSlice(state, courseId);
  return !!meta && hasStarted(meta);
}

export function allSectionStatsForCourseFetchSucceeded(
  state: CrudBuilderState,
  courseId: string
): boolean {
  const meta = getSectionStatFetchStateSlice(state, courseId);

  return !!meta && didSucceed(meta);
}

export function allSectionStatsForCourseFetchErrored(
  state: CrudBuilderState,
  courseId: string
): boolean {
  const meta = getSectionStatFetchStateSlice(state, courseId);
  return !!meta && didError(meta);
}

export function allSectionStatsForCourseFetchFinished(
  state: CrudBuilderState,
  courseId: string
) {
  return (
    allSectionStatsForCourseFetchSucceeded(state, courseId) ||
    allSectionStatsForCourseFetchErrored(state, courseId)
  );
}

export function allSectionStatsForCourseNeedsFetching(
  state: CrudBuilderState,
  courseId: string
) {
  return !(
    allSectionStatsForCourseFetchSucceeded(state, courseId) ||
    allSectionStatsForCourseFetching(state, courseId)
  );
}
